module.exports = __webpack_public_path__ + "img/1578854498.ec7afd52.jpg";